import { AppAction } from '../types';
import {
  SupportCategory,
  SupportEvent,
  SupportStateSupportImage,
  SupportSubCategory,
  Pagination,
} from './SupportTypes';

export const SET_SUPPORT_IMAGE = 'SET_SUPPORT_IMAGE';

export const REMOVE_SUPPORT_IMAGE = 'REMOVE_SUPPORT_IMAGE';
export const SET_SUPPORT_CATEGORIES = 'SET_SUPPORT_CATEGORIES';
export const SET_SUPPORT_SUB_CATEGORIES = 'SET_SUPPORT_SUB_CATEGORIES';
export const SET_SUPPORT_EVENTS = 'SET_SUPPORT_EVENTS';
export const SET_SUPPORT_EVENTS_PAGES = 'SET_SUPPORT_EVENTS_PAGES';
export const SET_SUPPORT_EVENTS_ACTIVE_PAGE = 'SET_SUPPORT_EVENTS_ACTIVE_PAGE';
export const SET_SUPPORT_EVENTS_COUNT_TO_SHOW =
  'SET_SUPPORT_EVENTS_COUNT_TO_SHOW';

export interface SetSupportCategoriesActionType {
  type: typeof SET_SUPPORT_CATEGORIES;
  payload: SupportCategory[];
}

export interface RemoveSupportImageActionType {
  type: typeof REMOVE_SUPPORT_IMAGE;
  index?: number;
}

export interface SetSupportSubCategoriesActionType {
  type: typeof SET_SUPPORT_SUB_CATEGORIES;
  payload: SupportSubCategory[];
}

export interface setSupportImageActionType {
  type: typeof SET_SUPPORT_IMAGE;
  payload?: SupportStateSupportImage[];
}

export interface SetSupportEventsActionType {
  type: typeof SET_SUPPORT_EVENTS;
  payload: SupportEvent[];
}

export interface SetSupportEventsActivePageActionType {
  type: typeof SET_SUPPORT_EVENTS_ACTIVE_PAGE;
  page: number;
}

export interface SetSupportEventsCountToShowActionType {
  type: typeof SET_SUPPORT_EVENTS_COUNT_TO_SHOW;
  count: number;
}

export interface SetSupportEventsPagesActionType {
  type: typeof SET_SUPPORT_EVENTS_PAGES;
  pages: number;
}

export type SupportActions =
  | setSupportImageActionType
  | SetSupportCategoriesActionType
  | SetSupportSubCategoriesActionType
  | RemoveSupportImageActionType
  | SetSupportEventsActionType
  | SetSupportEventsActivePageActionType
  | SetSupportEventsCountToShowActionType
  | SetSupportEventsPagesActionType;

export type SupportThunkAction<T = void> = AppAction<SupportActions, T>;
